<template>
	<div class="bottom-panel default-font" id="status-panel">
		<div class="flex items-center">
			<GlyphIcon :icon="icon(!ss.runtime.networkError)" size="14" :color="color(!ss.runtime.networkError)" />
			<div class="lbl">{{ t('statuspanel.network') }}</div>

			<GlyphIcon :icon="icon(realtime.connected)" size="14" :color="color(realtime.connected)" />
			<div class="lbl">{{ t('statuspanel.realtime') }}</div>

			<GlyphIcon :icon="icon(ss.isAuthenticated)" size="14" :color="color(ss.isAuthenticated)" />
			<div class="lbl">{{ t('statuspanel.authentication') }}</div>

			<GlyphIcon :icon="icon(employees.isReady)" size="14" :color="color(employees.isReady)" />
			<div class="lbl">{{ t('statuspanel.employees') }}</div>

			<GlyphIcon :icon="icon(dashboards.ready)" size="14" :color="color(dashboards.ready)" />
			<div class="lbl">{{ t('statuspanel.layout') }}</div>

			<GlyphIcon :icon="icon(phonebook.isReady)" size="14" :color="color(phonebook.isReady)" />
			<div class="lbl">{{ t('statuspanel.phonebook') }}</div>

			<GlyphIcon v-if="ss.runtime.isEmbedded" :icon="icon(electron.connected)" size="14" :color="color(electron.connected)" style="margin-top:-1px" />
			<div v-if="ss.runtime.isEmbedded" class="lbl">{{ t('statuspanel.appApi') }}</div>

			<GlyphIcon v-if="ss.settings.softphoneId" :icon="icon(sipClient.registered.value)" size="14" :color="color(sipClient.registered.value)"  />
			<div class="lbl" v-if="ss.settings.softphoneId">{{ t('statuspanel.sipClient') }}</div>

			<GlyphIcon v-if="sipClient.headsets.jabra.use.value" :icon="icon(true)" size="14" :color="color(true)" />
			<div v-if="sipClient.headsets.jabra.use.value" class="lbl">{{ t('statuspanel.headset') }}: {{ sipClient.headsets.jabra.useDeviceName }}</div>

			<GlyphIcon v-if="sipClient.headsets.sennheiser.use.value" :icon="icon(true)" size="14" :color="color(true)" />
			<div v-if="sipClient.headsets.sennheiser.use.value" class="lbl">{{ t('statuspanel.headset') }}: {{ sipClient.headsets.sennheiser.useDeviceName }}</div>

			<GlyphIcon v-if="sipClient.headsets.yealink.use.value" :icon="icon(true)" size="14" :color="color(true)" />
			<div v-if="sipClient.headsets.yealink.use.value" class="lbl">{{ t('statuspanel.headset') }}: {{ sipClient.headsets.yealink.useDeviceName }}</div>

			<GlyphIcon :icon="icon(ss.settings.media.kuando.use)" size="14" :color="color(ss.settings.media.kuando.use)"
				v-if="ss.settings.media.kuando.use" />
			<div class="lbl" v-if="ss.settings.media.kuando.use">{{ t('statuspanel.busylight') }}</div>

			<GlyphIcon :icon="icon(ss.runtime.isEmbedded&&electron.isReceivingBeaconEvents)" size="14" :color="color(ss.runtime.isEmbedded&&electron.isReceivingBeaconEvents)"
				v-if="ss.runtime.isEmbedded" />
			<div class="lbl" v-if="ss.runtime.isEmbedded">{{ t('statuspanel.beacon') }}</div>

		</div>
		<div class="">{{ ss.runtime.appName }} {{ ss.runtime.version }}{{ ss.runtime.isEmbedded ? '-' + ss.runtime.wrapperVersion : '' }}</div>
	</div>
</template>

<script setup lang="ts">
import { useSettingsStore } from '@/stores/Settings'
import { useRealtimeStore } from '@/stores/Realtime'
import { useEmployeesStore } from '@/stores/Employees'
import { useDashboardsStore } from '@/stores/Dashboards'
import { usePhonebookStore } from '@/stores/Phonebook'
import { useElectronStore } from '@/stores/Electron'
import GlyphIcon from '@/components/GlyphIcon.vue'
import SipClient from '@/utilities/SipClient'
import { useI18n } from 'vue-i18n'
import { GlyphIconName } from '@/stores/GlyphIcons.types'

const ss = useSettingsStore()
const realtime = useRealtimeStore()
const employees = useEmployeesStore()
const dashboards = useDashboardsStore()
const phonebook = usePhonebookStore()
const electron = useElectronStore()
const sipClient = SipClient.instance
const { t } = useI18n()

function icon(on: boolean) {
	return on ? GlyphIconName['circle-check'] : GlyphIconName['circle-remove']
}

function color(on: boolean) {
	return on ? '#00cc00' : '#ff0000'
}

</script>

<style scoped>
	.bottom-panel {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		height: 20px;
		background-color: var(--status-panel-background);
		color: var(--status-panel-color);
		padding-left: 10px;
		padding-right: 10px;
		display: flex;
		justify-content: space-between;
		overflow: hidden;
		border-top: var(--status-panel-border-top);
		font-size: 11px;
		z-index: 50;
	}
	.lbl {
		padding-left: 1px;
		padding-right: 10px;
	}
</style>
